import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { AuthSevices, ClaimService, ClientService } from '@fitness-force/api';
import { BehaviorSubject, Observable } from 'rxjs';
import { Claim, ClientCreditBalance, ClientCreditBalanceListResponse, RefundData, RefundType, TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { environment } from '@fitness-force/environments';
import { TENANTS_INFO } from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { ProcessRefundComponent } from '@fitness-force/refund';

@Component({
  selector: 'fitness-force-client-credit-balance',
  templateUrl: './client-credit-balance.component.html',
  styleUrls: ['./client-credit-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    TableModule,
    ButtonModule,
    PopoverModule,
    RippleModule,
    CurrencyformatPipe,
    ProcessRefundComponent,
    TranslateModule, AsyncPipe, NgClass],
})
export class ClientCreditBalanceComponent implements OnInit {
  private readonly store = inject(Store);
  readonly translate = inject(TranslateService);
  private readonly clientService = inject(ClientService);
  private readonly claimService = inject(ClaimService);
  private readonly authService = inject(AuthSevices);

  readonly visible = input<boolean>(false);
  readonly clientId = input<number>(0);
  readonly closePopup = output<{ action: string } | boolean>();

  claims: string[] = ['can_do_billing'];
  claim$: Observable<Claim[]> = new Observable();
  clientCreditBalance$ = new BehaviorSubject<ClientCreditBalance[]>([]);
  allTenants: any;
  currentUserDetails: any;
  showRefund  = new BehaviorSubject<boolean>(false);
  refundData:RefundData= {} as RefundData;
  loadTable: boolean= true;

  ngOnInit(): void {
    this.loadTable=true;
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.currentUserDetails = this.authService.decodedToken;
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants= tenant.all_tenant;
    });
    this.clientService.getClientCreditBalanceList(this.clientId()).subscribe({
      next: (res:ClientCreditBalanceListResponse) => {
        this.clientCreditBalance$.next(res.items ? res.items : []);
        this.loadTable=false;
      },
      error: () => {
        this.clientCreditBalance$.next([]);
        this.loadTable=false;
      }
    });
  }

  getTenant(tenantId:number)
  {
    return this.allTenants.find((o: { id: number; }) => o.id == tenantId);
  }

  ProcessRefund(balance:ClientCreditBalance)
  {
      this.refundData.amount = balance.available_credit_balance;
      this.refundData.tenantId = balance.tenant_id;
      this.refundData.refundType = RefundType.CreditBalance;
      this.refundData.clientId= this.clientId();
      this.refundData.primaryId=0;
      this.refundData.isOnline= false;
      this.refundData.paymentGateway= null;
      this.showRefund.next(true);      
  }

  closeRefundDialogEvent(event:any)
  {
    this.showRefund.next(false);
    if(event.reloadData)
    {
      this.clientService.getClientCreditBalanceList(this.clientId()).subscribe({
        next: (res:ClientCreditBalanceListResponse) => {
          this.clientCreditBalance$.next(res.items ? res.items : []);
        },
        error: () => {
          this.clientCreditBalance$.next([]);
        }
      });
    }
    this.closeCreditPopup(event.reloadData);
  }

  closeCreditPopup(update:boolean)
  {
    this.closePopup.emit(update ? { action: "updated" } : update);
  }

  closeDialog()
  {
    this.closeCreditPopup(false);
  }
  

  get hasAdminBilling(): boolean {
    return this.currentUserDetails.can_admin_billing == 'true' ? true : false;
  }

}